import { PropertiesDataProvider } from '../context/PropertiesContext';
import { Properties } from './Properties';
import { CustomerDataProvider } from '../../customers/context/CustomersContext';

export default function PropertiesPage() {
  return (
    <CustomerDataProvider>
      <PropertiesDataProvider>
        <Properties />
      </PropertiesDataProvider>
    </CustomerDataProvider>
  );
};
